import React from 'react';

import Icon, { IconName, IconSizes } from '@Components/Icon';
import Row from '@Components/layout/Row';
import Typography from '@Components/Typography';

import styles from './ContactBox.module.scss';

export interface ContactBoxProps {
  icon: IconName;
  text: string;
}

const ContactBox: React.FunctionComponent<ContactBoxProps> = ({ icon, text }) => {
  return (
    <Row constant alignCenter className={styles.contactBoxWrapper}>
      <div>
        <Icon icon={icon} size={IconSizes.m} />
      </div>
      <Typography msg={text} tag="span" html color="black" />
    </Row>
  );
};

export default ContactBox;
